import { createSlotRecipe } from './runtime.js';

const chatResultSummaryConfig = {"name":"chatResultSummary","slots":["root","header","icon","headings","title","summary","badges","actions","followUps","followUpLabel","followUpList"],"defaultVariants":{"status":"success"},"variantMap":{"status":["failed","partial","success"]}}

export const chatResultSummary = /* @__PURE__ */ createSlotRecipe(chatResultSummaryConfig)